<template>
  <CollapsePanel
    ref="panel"
    class="trarepl_panel trarepl"
    :toRight="true"
    :hasOpener="false"
    :noTrigger="true"
    :focusMode="true"
    :ignoreSwipe="true"
    :open="open"
    :toggleFn="close"
    tabindex="0"
    style="--content-padding: 0"
    @keydown.stop.escape="close"
    @update:open="focusPanel"
    @mouseenter="focusPanel(true), setActiveNamespace()"
  >
    <template #before>
      <div
        class="trarepl_overlay"
        :class="{ trarepl_overlay_invisible: !open }"
        @click="close"
      />
    </template>
    <template #content>
      <div
        ref="cont"
        class="trarepl_content"
        :style="`--trainer-fnt-size: ${fntSize}`"
      >
        <div
          v-show="open"
          class="icon_btn f-center trarepl_opener position-absolute csst mdi mdi-close clr-grey"
          @click="close"
        >
          <div
            class="csst_content text-nowrap clr-white"
            style="transform: translate(calc(50% + 1.5rem), 0)"
            v-html="$t('common.close_key', { key: 'Esc' })"
          ></div>
        </div>
        <div
          v-if="loading"
          class="trarepl_loading anim-fade-in"
        >
          <LoaderSpinner
            class="ma-auto"
            :style="`--size: 4rem`"
          />
        </div>
        <Trainer
          class="trarepl_trainer"
          style="--focus-mode-center-margin: 0 auto auto auto; font-size: clamp(1px, 1rem, 1.8vh)"
          :forceFocusMode="true"
          :hasMultipleTables="false"
          :hasSession="false"
          :hasStreak="false"
          :namespace="namespace"
          :active="open"
          :replayOnly="true"
          :hasTopStreetBtns="hasTopStreetBtns"
          :historyHand="historyHand"
          :hasStudySpotBtn="hasStudySpotBtn"
          :sessionInProgress="sessionInProgress"
          :restoreHandOnly="restoreHandOnly"
          :hasConfirmBtns="open && hasConfirmBtns"
          :hasResultSwitcher="open && hasResultSwitcher"
          :hasSilentFetch="hasSilentFetch"
          :repeatHandBtnAsPrimary="true"
          :opponentHandOnlyOnShowdown="opponentHandOnlyOnShowdown"
          :confirmBtnsHasMenu="false"
          tstPrefix="trainer_replay_"
        />
      </div>
    </template>
  </CollapsePanel>
</template>

<script>
import { nextTick } from 'vue'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import CollapsePanel from '@/components/CollapsePanel/CollapsePanel'
import Trainer from '@/components/Trainer/Trainer'

export default {
  name: 'TrainerReplay',
  components: {
    CollapsePanel,
    Trainer,
    LoaderSpinner,
  },
  props: {
    open: Boolean,
    historyHand: Object,
    namespace: { required: true, type: String, default: 'tra/replay' },
    setNamespace: { type: Boolean, default: true },
    hasConfirmBtns: { type: Boolean, default: true },
    hasResultSwitcher: Boolean,
    hasSilentFetch: { type: Boolean, default: true },
    hasStudySpotBtn: { type: Boolean, default: true },
    hasTopStreetBtns: { type: Boolean, default: true },
    opponentHandOnlyOnShowdown: Boolean,
    sessionInProgress: Boolean,
    restoreHandOnly: Boolean,
    hasControlIcons: Boolean,
    controlsIconsProps: Object, // Is this dead, or is it used?
    loading: Boolean,
  },
  data() {
    return {
      fntSize: '1rem',
    }
  },
  beforeUnmount() {
    this.close()
  },
  methods: {
    close() {
      this.$store.commit(`panels_set`, { key: 'panel_replay', value: false })
      this.setActiveNamespace('tra/alpha')
    },
    focusPanel(bool) {
      // console.log('focusPanel', this.$refs.panel, bool)
      if (this.$refs.panel && bool) {
        this.$refs.panel.$el.focus()
      }
    },
    setActiveNamespace(nn) {
      if (!this.open || !this.setNamespace) return
      this.$store.dispatch(`hands_set_active_namespace`, { namespace: nn || 'tra/replay' })
    },
    setFntSize() {
      if (this.mobile) return
      const { cont } = this.$refs
      if (cont) {
        let size = null
        const { width } = cont.getBoundingClientRect()
        const sizeWidth = this.getSizeByWidth1(width)
        size = sizeWidth ? `${sizeWidth}px` : '1rem'
        // console.log({
        //   size,
        //   sizeWidth,
        //   width,
        // })
        this.fntSize = size
      }
    },
    getSizeByWidth1(boxWidth) {
      let size = 0
      const b = [
        [1000, 13],
        [950, 12.5],
        [900, 12],
        [850, 11.75],
        [825, 11.5],
        [800, 11],
        [775, 10.75],
        [750, 10.5],
      ]
      b.forEach(([w, s]) => {
        if (boxWidth < w) {
          size = s
        }
      })
      return size
    },
  },
  computed: {
    mobile() {
      return this.$store.getters.globals_mobile
    },
    globals_window_size() {
      return this.$store.getters.globals_window_size
    },
  },
  watch: {
    open() {
      nextTick(() => {
        this.setFntSize()
      })
    },
    globals_window_size() {
      nextTick(() => {
        this.setFntSize()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.trarepl {
  --p-replay-left: 20rem;
  --open-width: clamp(52rem, 76rem, calc(100vw - var(--p-replay-left) - 3rem));
  --closed-width: 0;
  --clr-back: var(--clr-black-0-1);
  --inner-right-hidden-open: var(--p-replay-left);

  position: fixed !important;
  // left: calc(-1 * var(--open-width) - 20rem);
  // left: calc(-1 * var(--open-width));
  // right: calc(-1 * var(--open-width));

  // background: var(--clr-black-1);
  // height: 100%;
  &_content {
    flex: 1;
    // padding: 1.5rem 0 0 0;
    --trainer-fnt-size: 1rem;
    font-size: var(--trainer-fnt-size);
    position: relative;
    height: 100%;
  }
  &_loading {
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    height: var(--vh-3);
    width: 100%;
    display: flex;
    z-index: 4;
  }
  &_trainer {
    --glo-hs-back: var(--clr-black-0-1);
    --hs-margin: 0.5rem 0 0 0;
  }
  &_opener {
    position: absolute !important;
    left: 0.5rem;
    top: 0.5rem;
    z-index: 3;
    padding: 0.25rem;
    font-size: 1.5rem;
    color: var(--clr-white-0);
  }
  &_overlay {
    position: fixed;
    left: -100vw;
    top: -50vh;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    opacity: 1;
    height: 300vh;
    width: 300vw;
    transition: opacity 0.22s;
    &_invisible {
      opacity: 0;
      width: 0vw;
      animation: delayShrink 0.22s;
      @keyframes delayShrink {
        0% {
          width: 300vw;
        }
        1000% {
          width: 300vw;
        }
      }
    }
  }
}

@media screen and (max-width: 1023px) {
  .trarepl {
    --open-width: 100vw;
    --inner-right-hidden-open: var(--p-replay-left);
    &_content {
      min-height: var(--vh-3);
      max-height: var(--vh-3);
    }
    &_trainer {
      --hs-margin: 2.5rem 0 0 0;
      --hs-width: 10;
    }
  }
}
</style>
